export enum UrlParam {
  discount = 'discount',
  fulfillments = 'fulfillments',
  subscription = 'subscription',
  customInstruction = 'customInstruction',
  tableNumber = 'tableNumber',
  sharedOrderId = 'sharedOrderId',
  sharedOwnerId = 'sharedOwnerId',
  cartItems = 'cartItems',
  sharedOrderIds = 'sharedOrderIds'
}
